<template>
    <mySubPage>
        <div slot="header">
            <myNav>{{$t('upd_sub_shop')}}</myNav>
        </div>
        <el-form class="pd-10" ref="form" :model="formData" :rules="rule" label-width="120px">
            <el-form-item :label="$t('logo_img')" prop="img_lnk">
                <myCropImg :autoCropWidthHeight="[400,400]" crop_height="450px" crop_width="450px" :original_url="formData.img_lnk" @cropImgUpload="setOrgIcon"></myCropImg>
            </el-form-item>
            <el-form-item :label="$t('build_img')" prop="build_img_lnk">
                <myCropImg :autoCropWidthHeight="[600,360]" crop_height="500px" crop_width="700px" :original_url="formData.build_img_lnk" @cropImgUpload="setOrgBuildImg"></myCropImg>
            </el-form-item>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('code')" prop="org_code">
                        <el-input v-model="formData.org_code" :placeholder="$t('input')" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('cname')" prop="org_cname">
                        <el-input v-model="formData.org_cname" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('org_mod_cname')" prop="mod_id">
                        <el-select class="fillw" v-model="formData.mod_id" :placeholder="$t('select')" disabled>
                            <el-option :label="item.mod_cname"  :value="item.mod_id" v-for="item in mods" :key="item.mod_id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('join_type_cname')" prop="join_type">
                        <el-select class="fillw" v-model="formData.join_type" :placeholder="$t('select')" disabled>
                            <el-option :label="item.type_cname"  :value="item.join_type" v-for="item in join_type" :key="item.join_type"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('link_cname')" prop="link_cname">
                        <el-input v-model="formData.link_cname" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('link_mobile')" prop="link_mobile">
                        <el-input v-model="formData.link_mobile" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('cu_cname')" prop="cu_cname">
                        <el-input v-model="formData.cu_cname" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('cu_mobile')" prop="cu_mobile">
                        <el-input v-model="formData.cu_mobile" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('cu_time_area')" prop="cu_time_area">
                        <el-input v-model="formData.cu_time_area" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--省市区选择-->
            <el-form-item :label="$t('addr2')" prop="addrLabel">
                <el-cascader class="fillw" :options="addrData" trigger="click" :filterable="true" v-model="formData.addrLabel"
                             ref="ref_addr" @change="addrValueChang" :props="{value:'label'}"></el-cascader>
            </el-form-item>
            <!--详细地址-->
            <el-form-item :label="$t('addr')" prop="addr">
                <el-input v-model="formData.addr" :placeholder="$t('input')"></el-input>
            </el-form-item>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('lng')" prop="">
                        <el-input v-model="formData.lng" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('lat')" prop="">
                        <el-input v-model="formData.lat" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" v-if="mod_cat == 'M1'">
                    <el-form-item :label="$t('admin_code')" prop="admin_code">
                        <el-input v-model="formData.admin_code" :placeholder="$t('input')" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('org_admin_code')" prop="org_admin_code">
                        <el-input v-model="formData.org_admin_code" :placeholder="$t('input')" disabled></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12"><el-form-item :label="$t('add_user')"><el-input v-model="formData.add_user" disabled></el-input></el-form-item></el-col>
                <el-col :span="12"><el-form-item :label="$t('add_time')"><el-input v-model="formData.add_time" disabled></el-input></el-form-item></el-col>
            </el-row>
            <el-row>
                <el-col :span="12"><el-form-item :label="$t('upd_user')"><el-input v-model="formData.upd_user" disabled></el-input></el-form-item></el-col>
                <el-col :span="12"><el-form-item :label="$t('upd_time')"><el-input v-model="formData.upd_time" disabled></el-input></el-form-item></el-col>
            </el-row>
        </el-form>
        <div slot="footer">
            <div class="flex-box bg-f8">
                <div class="flex-box-bd"></div>
                <el-button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</el-button>
                <el-button type="primary" @click="submit">{{$t('save')}}</el-button>
            </div>
        </div>
    </mySubPage>
</template>

<script>
    import myCropImg from '../../../components/myCropImg'
    import addr from '../../../utils/addr/index'
    export default {
        components:{
            myCropImg
        },
        data:function(){
            return{
                relist:false,
                mod_cat:this.$base.getModCat(),
                formData: {
                    org_id:'',
                    img_lnk: "",
                    build_img_lnk: "",
                    org_code: "",
                    org_cname: "",
                    mod_id: "",
                    join_type:'',
                    link_cname: "",
                    link_mobile: "",
                    cu_cname: "",
                    cu_mobile: "",
                    cu_time_area: "",
                    prov: "",
                    city: "",
                    area: "",
                    addrLabel:[],
                    addr: "",
                    lng:'0', // 经度
                    lat:'0',  // 维度
                    admin_code: "",
                    org_admin_code: "",
                    add_user:'',
                    add_time:'',
                    upd_user:'',
                    upd_time:'',
                },
                rule: {
                    img_lnk: [{required: true, message: this.$t('input'), trigger: 'change'}],
                    org_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    link_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    link_mobile: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    addr: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                },
                addrData: [],
                mods:[],
                join_type: [],
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.formData.org_id = this.$base.getRequest().id;
            this.getInfo();
            setTimeout(() => {
                this.addrData = addr.getAddrData()
            }, 500);
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            addrValueChang(value){
                this.formData.prov = value[0];
                this.formData.city = value[1];
                this.formData.area = value[2];
            },
            setOrgBuildImg: function (file_path) {
                this.formData.build_img_lnk = file_path;
            },
            setOrgIcon: function (file_path) {
                this.formData.img_lnk = file_path;
            },
            getInfo: function(){
                var data = {
                    org_id: this.formData.org_id
                };
                this.$base.showLoading();
                this.$request.sendPost("org-shop/before-upd",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.mods = data.mods;
                        this.join_type = data.join_type;
                        this.formData = this.$base.leftJson(this.formData,data.info);
                        this.formData.addrLabel=[this.formData.prov,this.formData.city,this.formData.area];
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        this.$base.showLoading();
                        this.$request.sendPost('org-shop/upd',this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.msgSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.msgErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/shop/save.vue